module.exports = __webpack_public_path__ + "static/img/ihago_logof.6a078822.png";